export const environment = {
  production: true,
  version: '2.0.0'
};
